import {
    SimpleShowLayout,
    usePermissions,
    useRecordContext,
    useResourceContext,
} from "react-admin";
import { Box, CircularProgress } from "@mui/material";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaShowView } from "shared/src/components/views/RaShowView";
import { RepairItemsTable } from "./components/RepairItemsTable";
import { Spacer } from "shared/src/components/styles/Spacer";
import { ContractDetails } from "../components/ContractDetails";
import { useInfiniteScroll } from "shared/src/hooks/useInfiniteScroll";

export const RepairOrderShow = () => {
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }

    return (
        <RaShowView actions={<ToolbarWithHistory back={true} edit={true} delete={true} />}>
            <SimpleShowLayout>
                <ContentWrapper />
            </SimpleShowLayout>
        </RaShowView>
    );
};

const ContentWrapper = () => {
    const rental = useRecordContext();

    const {
        data: rentalItems,
        isPending,
        isFetchingNextPage,
        observerRef,
    } = useInfiniteScroll(
        "rentalItems",
        {
            filter: { rental: rental?.id },
            pagination: { page: 1, perPage: 25 },
            sort: { field: "id", order: "ASC" },
        },
        { enabled: !!rental?.id }
    );

    if (isPending) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            <ContractDetails rentalItems={rentalItems} titleLabelKey={"equip.repairOrderDetails"} />
            <Spacer y={2} />
            <RepairItemsTable rentalItems={rentalItems} />
            <Box ref={observerRef} sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                {isFetchingNextPage && <CircularProgress size={24} />}
            </Box>
        </>
    );
};
